import { ForgotPassword } from '../components/Authentication/ForgotPassword/ForgotPassword'

export const ForgotPasswordPage = () => {
    return <ForgotPassword />
}
